"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { Box } from "@mui/material";
import { Button } from "@nxt-costco-com/forge-components";
import { SpaceLg, SpaceSm } from "@nxt-costco-com/forge-design-tokens";
import { addToListActions } from "../constants.js";
import { ShowNotification } from "./components/Notifications/ShowNotification.js";
import { ProductUI } from "./components/ProductUI.js";
import { focusIntoRef } from "./lib.js";
const SavedToList = (props) => {
  const notificationRef = useRef(null);
  const { state, product, dispatch, msStore } = props;
  const { errorMsg, successMsg, drawerContent } = state;
  const continueButtonLabel = msStore.getKeyValueItem("continuebuttonlabel");
  const viewListsButtonLabel = msStore.getKeyValueItem("viewlistbuttonlabel");
  useEffect(() => focusIntoRef(notificationRef), []);
  return /* @__PURE__ */ jsxs(Box, { id: "added-to-list-container", children: [
    /* @__PURE__ */ jsx("span", { "aria-live": "polite", ref: notificationRef, tabIndex: -1, children: /* @__PURE__ */ jsx(ShowNotification, { errorMsg, successMsg }) }),
    /* @__PURE__ */ jsx(
      ProductUI,
      {
        dispatch,
        msStore,
        product,
        showQuantity: true,
        showQuantitySelector: false,
        state
      }
    ),
    /* @__PURE__ */ jsxs(
      Box,
      {
        sx: {
          display: "flex",
          flexDirection: "column",
          gap: SpaceSm,
          marginTop: SpaceLg
        },
        children: [
          /* @__PURE__ */ jsx(Button, { href: "/NonAjaxAccountListDisplayView", variant: "primary", children: viewListsButtonLabel }),
          /* @__PURE__ */ jsx(
            Button,
            {
              onClick: () => {
                const updatedDrawerContent = [...drawerContent];
                dispatch({
                  payload: {
                    addToListModalOpen: false,
                    drawerContent: updatedDrawerContent.slice(
                      0,
                      -1
                    ),
                    errorMsg: "",
                    isLoading: false,
                    selectedLists: [],
                    successMsg: ""
                  },
                  type: addToListActions.UPDATE_STATE
                });
              },
              onKeyDown: (e) => {
                if (e.key === "Enter") {
                  const updatedDrawerContent = [...drawerContent];
                  dispatch({
                    payload: {
                      addToListModalOpen: false,
                      drawerContent: updatedDrawerContent.slice(
                        0,
                        -1
                      ),
                      errorMsg: "",
                      isLoading: false,
                      selectedLists: [],
                      successMsg: ""
                    },
                    type: addToListActions.UPDATE_STATE
                  });
                }
              },
              variant: "secondary",
              children: continueButtonLabel
            }
          )
        ]
      }
    )
  ] });
};
export {
  SavedToList
};
